import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DeviceFingerprintService } from './device-fingerprint.service';

/**
 * Device Fingerprint Interceptor
 *
 * Adds device identification headers (X-Screen-Resolution, X-Timezone, X-Platform)
 * to all outgoing HTTP requests targeting the backend API.
 *
 * These headers allow the backend's DeviceFingerprintExtractor to produce
 * richer fingerprints for token binding and device-based theft detection.
 *
 * Skips Azure Blob Storage URLs (they use SAS tokens, not our auth).
 */
export function deviceFingerprintIntercept(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const fingerprintService = inject(DeviceFingerprintService);

  // Skip Azure Blob Storage URLs — they use SAS token auth, not our headers
  if (req.url.includes('.blob.core.windows.net')) {
    return next(req);
  }

  const modifiedRequest = req.clone({
    setHeaders: fingerprintService.getDeviceHeaders(),
  });

  return next(modifiedRequest);
}
